import { UseQueryResult, useQuery } from 'react-query';
import { api } from '../api';

async function getHash(userId?: string): Promise<{ hash: string | null }> {
    const { data } = await api.get(`/users/${userId}/intercom-hash`);
    return data;
}

export function useIntercomHash(userId?: string): UseQueryResult<{ hash: string | null }, unknown> {
    return useQuery(['intercom-hash', userId], () => getHash(userId), {
        keepPreviousData: false,
        enabled: Boolean(userId),
    });
}
